import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';


import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TextFieldModule } from '@angular/cdk/text-field';

@Component({
  selector: 'app-chat-input',
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    TextFieldModule
],
  templateUrl: './chat-input.component.html',
  styleUrls: ['./chat-input.component.scss']
})
export class ChatInputComponent {
  @ViewChild('textareaEl') textareaEl!: ElementRef<HTMLTextAreaElement>;

  private _disabled = false;

  @Input()
  get disabled(): boolean {
    return this._disabled;
  }
  set disabled(value: boolean) {
    const wasDisabled = this._disabled;
    this._disabled = value;
    // Re-enable happened (AI finished responding) — restore focus
    if (wasDisabled && !value) {
      setTimeout(() => this.textareaEl?.nativeElement.focus(), 0);
    }
  }

  @Output() messageSent = new EventEmitter<string>();

  messageText = '';

  sendMessage(): void {
    const trimmedMessage = this.messageText.trim();
    if (trimmedMessage && !this.disabled) {
      this.messageSent.emit(trimmedMessage);
      this.messageText = '';
      // Fallback: keep focus when disabled never fires (e.g. instant response)
      setTimeout(() => this.textareaEl?.nativeElement.focus(), 0);
    }
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }
}
